import { ISalesRepState } from '@/store/sales-rep';
import { ISalesRepMutations } from './mutations.types';
import { IUserData } from '@/models';

export const mutations: ISalesRepMutations = {
  SET_SALES_REPS(state: ISalesRepState, payload: IUserData[]): void {
    state.salesReps = payload;
  },

  ADD_SALES_REP(state: ISalesRepState, payload: IUserData): void {
    state.salesReps.push(payload);
  },

  UPDATE_SALES_REP(state: ISalesRepState, payload: IUserData): void {
    const index = state.salesReps.findIndex(
      (salesRep: IUserData) => salesRep.id === payload.id
    );

    state.salesReps.splice(index, 1, payload);
  }
};
